import React from 'react'
import Kundhandelsetyp from "../../model/kundhandelsetyp";

import './ShowKundhandelsetyp.scss'

type ShowKundhandelsetypProps = {
    kundhandelsetyp: Kundhandelsetyp
}

const ShowKundhandelsetyp = (props: ShowKundhandelsetypProps) => {
    // console.log(props)
    const kundhandelsetyp = props.kundhandelsetyp

    const getJaNejText = (input: boolean): string => {
        return input ? "Ja" : "Nej"
    }

    return (
        <div className="container-fluid">
            <div className="row table-row">
                <div className="col-md-5 text-end">Identifierare</div>
                <div className="col-md-7">{kundhandelsetyp.getIdentifierare()}</div>
            </div>
            <div className="row table-row">
                <div className="col-md-5 text-end">Behörighetsobjekt</div>
                <div className="col-md-7">{kundhandelsetyp.behorigheter}</div>
            </div>
            <div className="row table-row">
                <div className="col-md-5 text-end">Möjliga språk</div>
                <div className="col-md-7">{kundhandelsetyp.mojligaSprak}</div>
            </div>
            <div className="row table-row">
                <div className="col-md-5 text-end">Producentärendet klart</div>
                <div className="col-md-7">{getJaNejText(kundhandelsetyp.producentarendetKlart)}</div>
            </div>
            <div className="row table-row">
                <div className="col-md-5 text-end">Producentärendet kräver kundåtgärd</div>
                <div className="col-md-7">{getJaNejText(kundhandelsetyp.producentarendetKraverKundatgard)}</div>
            </div>
            <div className="row table-row">
                <div className="col-md-5 text-end">Senast uppdaterad</div>
                <div className="col-md-7">{kundhandelsetyp.updatedAt ? kundhandelsetyp.updatedAt.toLocaleDateString("sv-SW") : ''}</div>
            </div>


        </div>
    )
}

export default ShowKundhandelsetyp